export const languagesData = [
    { label: "English", value: "en" },
    { label: "Hindi", value: "hi" },
    { label: "Bengali", value: "bn" },
    { label: "Telugu", value: "te" },
    { label: "Marathi", value: "mr" },
    { label: "Tamil", value: "ta" },
    { label: "Urdu", value: "ur" },
    { label: "Gujarati", value: "gu" },
    { label: "Kannada", value: "kn" },
    { label: "Odia", value: "or" },
    { label: "Malayalam", value: "ml" },
    { label: "Punjabi", value: "pa" },
    { label: "Assamese", value: "as" },
    { label: "Maithili", value: "mai" },
    { label: "Santali", value: "sat" },
    { label: "Kashmiri", value: "ks" },
    { label: "Nepali", value: "ne" },
    { label: "Konkani", value: "kok" },
    { label: "Sindhi", value: "sd" },
    { label: "Dogri", value: "doi" },
    { label: "Manipuri (Meitei)", value: "mni" },
    { label: "Bodo", value: "brx" }
  ];
  